// third-party
import { combineReducers } from 'redux';

// project import
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import algolia from './algolia';
import cartReducer from './cart';
import config from './config';
import currentContact from './currentContact';
import currentVenue from './currentVenue';
import currentEvent from './currentEvent';
import dialog from './dialog';
import menu from './menu';
import reportControls from './reportControls';
import notifications from './notifications';
import snackbar from './snackbar';
import dashboard from './dashboard';
import ui from './ui';
import gridStates from './gridStates';

// ==============================|| COMBINE REDUCERS ||============================== //

const reducers = combineReducers({
  menu: persistReducer(
    {
      key: 'menu',
      storage,
      keyPrefix: 'otm-'
    },
    menu
  ),
  snackbar,
  cart: persistReducer(
    {
      key: 'cart',
      storage,
      keyPrefix: 'otm-'
    },
    cartReducer
  ),
  reportControls: persistReducer(
    {
      key: 'reportControls',
      storage,
      keyPrefix: 'otm-'
    },
    reportControls
  ),
  algolia,
  gridStates: persistReducer(
    {
      key: 'gridStates',
      storage,
      keyPrefix: 'otm-'
    },
    gridStates
  ),
  currentEvent: persistReducer(
    {
      key: 'currentEvent',
      storage,
      keyPrefix: 'otm-'
    },
    currentEvent
  ),
  config: persistReducer(
    {
      key: 'config',
      storage,
      keyPrefix: 'otm-'
    },
    config
  ),
  currentContact,
  currentVenue,
  dialog,
  notifications,
  dashboard,
  ui: persistReducer(
    { key: 'ui', storage, keyPrefix: 'otm-', whitelist: ['panelStates', 'detailsView'] },
    ui
  )
});

export default reducers;
